<template>
  <div class="text-[#FFFFFF] text-14px h-full cockpit">
    <div class="h-1/3">
      <tableButtonGroup class="mt-10px" v-model="activeTab" :list="tabList" @btn-click="tabClick" />
      <categoryTitle class="my-10px" title="作业概况" />
      <div class="h-[calc(100%-84px)]">
        <div class="flex bill-today h-4/7 mb-10px">
          <div class="w-1/3"></div>
          <div class="w-2/3 mt-20px flex flex-col justify-evenly ">
            <div class="flex justify-between text-20px text-[#FF8900]">
              <div>{{ `${activeTab}开票` }}</div>
              <div>{{ ticketNum }}<span class=" text-12px  text-[#24e8ff]">个</span></div>
            </div>
            <div class="flex my-5px justify-between  opacity-70 text-[#FFFFFF]">
              <div>#1机组工作票(个)</div>
              <div>#2机组工作票(个)</div>
            </div>
            <div class="flex font-bold justify-between text-20px text-[#29F1FA] px-20px">
              <div>0</div>
              <div>0</div>
            </div>
          </div>
        </div>
        <div class="flex h-1/2 justify-between">
          <div class="w-49/100 tiket-bg h-full">
            <div class="flex  h-full">
              <div class="w-2/5 flex flex-col py-5px  justify-center">
                <div class="ml-10px works-number w-40px h-40px"></div>
              </div>
              <div class="w-3/5 flex flex-col justify-around">
                <div class="mt-10px">当前作业人数</div>
                <div class="flex justify-between h-30px mt-10px leading-30px">
                  <div class="text-18px text-[#45f2eb]">{{ currentWorkerNum }}</div>
                  <div class="text-12px mr-10px opacity-80">人</div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-49/100 ">
            <div class="flex tiket-bg   h-full">
              <div class="w-2/5 flex flex-col py-5px  justify-center">
                <div class="ml-10px break-count w-40px h-40px"></div>
              </div>
              <div class="w-3/5 flex flex-col justify-around">
                <div class="mt-10px">违章次数</div>
                <div class="flex justify-between mt-10px h-30px leading-30px">
                  <div class="text-18px text-[#45f2eb]">{{ violationNum }}</div>
                  <div class="text-12px mr-10px opacity-80">次</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-2/3 pb-10px">
      <categoryTitle title="作业清单" />
      <tableButtonGroup
        class="mt-10px"
        v-model="workActive"
        :list="workList"
        @btn-click="workClick"
      />
      <el-table
        class="mt-10px"
        :data="tableData"
        height="76%"
        highlight-current-row
        v-loading="tableDataLoading"
        @selection-change="tableSelect"
        ref="singleTable"
        v-el-table-infinite-scroll="loadMore"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          label="工作票类型"
          show-overflow-tooltip
          prop="ticketTypeName"
        ></el-table-column>
        <el-table-column
          label="工作票内容"
          show-overflow-tooltip
          prop="prWorkContent"
        ></el-table-column>
        <el-table-column
          label="作业时间"
          show-overflow-tooltip
          prop="prLicenseStartTime"
        ></el-table-column>
      </el-table>
      <div
        class="text-center circuit-mon h-38px leading-38px  font-16px"
        @click="operationTicketDetail"
      >
        启用巡回监控
      </div>
    </div>
  </div>
</template>

<script>
import { WorkTicketApi, OperateTicketApi } from '@wiz-api/huizhou2'
import { OperationSecurityApi } from '@wiz-api/huizhou2-business'
import { forEach, map, find, isEmpty } from 'lodash'
import elTableInfiniteScroll from 'el-table-infinite-scroll'
import tableButtonGroup from './components/TableButtonGroup'
import categoryTitle from '../../../../components/cockpit/CategoryTitle'

const workTicketApi = new WorkTicketApi()
const operateTicketApi = new OperateTicketApi()
const operationSecurityApi = new OperationSecurityApi()

export default {
  name: 'operation-safety-page',
  props: {},
  components: { tableButtonGroup, categoryTitle },
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll,
  },
  data() {
    return {
      tableDataLoading: false,
      tableOpDataLoading: false,
      workActive: '全厂票数',
      activeTab: '今日',
      ticketType: null,
      dataType: 1,
      ticketNum: 0,
      currentWorkerNum: 0,
      violationNum: 0,
      page: {
        pageNo: 1,
        pageSize: 8,
        totalCount: 0,
      },
      tableChecked: [],
      ticketTypeDic: [],
      ticketStateDic: [],
      tableData: [],
      workList: [],
      tabList: ['今日', '本周'],
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    // 获取开票数量
    async getTicketsNum() {
      const [err, res] = await operationSecurityApi.getInvoice({
        type: this.dataType,
      })
      if (!err) {
        this.ticketNum = res
      }
    },
    // 获取当前作业人数
    async getWorkerNum() {
      const [err, res] = await operationSecurityApi.getCurrebtWorkNum()
      if (!err) {
        this.currentWorkerNum = res
      }
    },
    // 获取违章次数
    async getViolationNum() {
      const [err, res] = await operationSecurityApi.getViolationCount({
        type: this.dataType,
      })
      if (!err) {
        this.violationNum = res
      }
    },
    // 获取工作票列表
    async getTicketsList(needReset = false) {
      if (needReset) {
        this.tableData = []
        this.page.pageNo = 1
        this.page.totalCount = 0
      }
      this.tableDataLoading = true
      const [err, res] = await operationSecurityApi.getWorkTicketListAync({
        type: this.dataType,
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          ticketTypes: this.ticketType,
        },
      })
      this.tableDataLoading = false
      if (!err && res?.data?.items?.length) {
        forEach(res.data.items, (item) => {
          if (item.prTicketType) {
            const ticketInfo = find(this.ticketTypeDic, ['value', item.prTicketType])
            item.ticketTypeName = ticketInfo?.name
          } else {
            item.ticketTypeName = null
          }
        })
        this.tableData.push(...res.data.items)
        this.page.totalCount = res.data.totalCount
      }
    },
    // 初始化基础字典数据
    initDictionary() {
      this.ticketTypeDic = [
        {
          value: 'ELECTRICAL_FIRST',
          name: '电气第一种工作票',
        },
        {
          value: 'ELECTRICAL_SECOND',
          name: '电气第二种工作票',
        },
        {
          value: 'MECHANICAL',
          name: '机械工作票',
        },
        {
          value: 'DONGHUO_LEVEL_ONE',
          name: '一级动火工作票',
        },
        {
          value: 'DONGHUO_LEVEL_TWO',
          name: '二级动火工作票',
        },
        {
          value: 'THERMAL_CONTROL',
          name: '热控工作票',
        },
      ]
      this.ticketStateDic = [
        {
          value: 'WaitCommit',
          name: '待提交',
        },
        {
          value: 'WaitApprove',
          name: '待审批',
        },
        {
          value: 'Executing',
          name: '正在执行',
        },
        {
          value: 'Finished',
          name: '已完成',
        },
        {
          value: 'Cancel',
          name: '已作废',
        },
        {
          value: 'Expired',
          name: '已过期',
        },
        {
          value: 'Archived',
          name: '已归档',
        },
      ]
      this.workList = map(this.ticketTypeDic, 'name')
      this.workList.unshift('全厂票数')
    },
    // 单选
    tableSelect(val) {
      if (val.length > 1) {
        this.$refs.singleTable.clearSelection()
        this.$refs.singleTable.toggleRowSelection(val[val.length - 1])
        this.tableChecked = [val[val.length - 1]]
      } else {
        this.tableChecked = val
      }
    },
    // 加载更多
    loadMore() {
      if (!this.tableDataLoading && this.tableData.length < this.page.totalCount) {
        this.page.pageNo += 1
        this.getTicketsList(false)
      }
    },
    // 打开工作票详情
    async operationTicketDetail() {
      if (isEmpty(this.tableChecked)) {
        this.$message.warning('请先选择工作票')
        return
      }
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'JobCardDetails',
            origin: 'tag',
            name: '作业卡',
          },
          type: 'tags',
          props: {
            modal: 'operation',
            data: this.tableChecked[0],
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    // 周期切换
    tabClick(val) {
      this.activeTab = val
      switch (this.activeTab) {
        case '今日':
          this.dataType = 1
          break
        case '本周':
          this.dataType = 2
          break
        default:
          break
      }
      this.getTicketsNum()
      this.getViolationNum()
      this.getTicketsList(true)
    },
    // 工作票类型切换
    workClick(val) {
      this.workActive = val
      // ticketTypeDic
      if (val === '全厂票数') {
        this.ticketType = null
      } else {
        this.ticketType = find(this.ticketTypeDic, ['name', val])?.value
      }
      this.getTicketsList(true)
    },
  },
  beforeDestroy() {},
  created() {
    // 初始化基础字典数据
    this.initDictionary()
    // 获取开票数量
    this.getTicketsNum()
    // 获取当前作业人数
    this.getWorkerNum()
    // 获取违章次数
    this.getViolationNum()
    // 获取工作票列表
    this.getTicketsList(true)
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-table thead {
  .el-table-column--selection .cell {
    display: none;
  }
}
.bill-today {
  background: url('../../assets/images/bill_today.png');
  background-size: 100% 100%;
}
.tiket-bg {
  background: url('../../assets/images/tiket.png');
  background-size: 100% 100%;
}
.works-number {
  background: url('../../assets/images/wokers_number.png');
  background-size: 100% 100%;
}
.break-count {
  background: url('../../assets/images/break_count.png');
  background-size: 100% 100%;
}
.circuit-mon {
  background: url('../../assets/images/circuit_mon.png');
  background-size: 100% 100%;
}
.work-bg {
  background: url('../../assets/images/callBg.png');
  background-size: 100% 100%;
}
.ranking-font {
  font-family: 'YouSheBiaoTiHei';
}
.work-state {
  font-family: 'PingFang SC';
}
.work-total {
  background: url('../../assets/images/workbg.png');
  background-size: 100% 100%;
}
::v-deep .el-tabs__item.is-active::after {
  display: none;
}
.my-tab ::v-deep.el-tabs__content {
  height: 90% !important;
}
</style>
